import {action, computed, observable, runInAction} from 'mobx';
import appStore from "../../app/store";
import sumBy from "lodash/sumBy";

const MIN_BYTES_PER_SECOND = 32 * 1024 + 1; // 32 kb/s

class UploadsProgressStore {
    // @observable uploadsList = [{fileId:'1', fileName:'test50.mp3', progress: 50}, {fileId:'2', fileName:'testFull.mp3', progress: 100}, {fileId:'3', fileName:'testErr.mp3', progress: -1, err:' error!!!!'}];
    @observable uploadsList = new Map();

    @action addUpload(fileId, fileName, fileManage, showNetworkSpeedAlert = false) {
        console.log("adding :: id - " + fileId + ",  name - " + fileName);
        this.uploadsList.set(fileId, {fileId, fileManage, progress: 0, showWarning: false, showNetworkSpeedAlert, parts: [{part: 1, progress: 0, loaded: 0, timestamp: Date.now()}]});
    }

    @action onUploadProgress = (fileId, {part, total, loaded}) => {
        const upload = this.getUploadFile(fileId);
        if (upload) {
            const now = Date.now();
            let partObj = upload.parts.find(u => u.part = part);
            if (!partObj) {
                partObj = {part: part, loaded: loaded, timestamp: now, total: total};
                upload.parts.push(partObj);
            } else if (upload.showNetworkSpeedAlert) {
                const kbps = (loaded - partObj.loaded) / ((now - partObj.timestamp) / 1000);
                // console.log(kbps);
                let showWarning = false;
                if (kbps < 0) {
                    appStore.createAlertFromMessageId('error', 'network.error.try.again', {}, 7000);
                } else if (kbps < MIN_BYTES_PER_SECOND) {
                    console.log('slow network: ', kbps);
                    showWarning = true;
                }
                if (!upload.showWarning && showWarning) {
                    // first time we detected an issue, show a warning
                    appStore.createAlertFromMessageId('warning', 'network.error', {}, 7000);
                    upload.showWarning = true;
                }
            }
            partObj.loaded = loaded;
            partObj.total = total;
            partObj.timestamp = now;

            loaded = sumBy(upload.parts, part => part.loaded);
            total = sumBy(upload.parts, part => part.total);
            upload.progress = Math.round(loaded / total * 96);
            upload.timestamp = now;
        }
    };

    @action finishUpload(fileId, isSuccess = true, err) {
        const upload = this.getUploadFile(fileId);
        if (upload) {
            upload.progress = isSuccess ? 100 : -1;
            if (isSuccess) {
                upload.isTemp = false;
            }
            upload.err = err;
        }
        if (isSuccess) {
            setTimeout(() => {
                runInAction(() => {
                    this.uploadsList.delete(fileId);
                });
            }, 5000);
        }
    }

    @action abortUpload = (id) => {
        const upload = this.getUploadFile(id);
        if (upload) {
            upload.fileManage.abort();
            this.uploadsList.delete(id);
        }
    };

    hasActiveUploads = () => {
        return this.uploadsList.values().filter(upload => upload.progress !== -1 && upload.progress !== 100).length > 0;
    }

    @computed get numActiveUploads() {
        return this.uploadsList.values().filter(upload => upload.progress !== -1 && upload.progress !== 100).length;
    }

    @action resetUploadsList = () => {
        this.uploadsList.values().forEach(upload => {
            if (upload.progress !== -1 && upload.progress !== 100 && upload.fileManage) {
                upload.fileManage.abort();
            }
        });
        this.uploadsList = new Map();
    }

    getUploadFile = (fileId) => {
        return this.uploadsList.get(fileId);
    }
}

const uploadsProgressStore = new UploadsProgressStore();
export default uploadsProgressStore;
